import { render } from "./IntegracaoExterna.vue?vue&type=template&id=71b92d89"
import script from "./IntegracaoExterna.vue?vue&type=script&lang=js"
export * from "./IntegracaoExterna.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__